import gsap from 'gsap'
import barba from '@barba/core'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { Navigation } from './navigation'
import { initLenis, lenis, scrollToStart, initParallax } from './lenis' 
import { initAlpine } from './alpine'
import { initPreloader } from './preloader'
import { initInviewAnimations } from './inview'
import { initProduct } from './product'
import { setTemplateName } from './utilities'
import { initCollections } from './collections'
import { initAnimations } from './animation'
import { initBannerWordTicker } from './bannerWordTicker'
import { initAbout } from './about'
import { initCursor } from './cursor'
import { initLottieAnimations } from './lottie'
import { initLogos } from './logos'
import { initSwiper } from './swiper'
import { initFragranceModel } from './fragrance'

gsap.registerPlugin(ScrollTrigger)

const initBarba = () => {
	window.initialLoad = true

	const nav = new Navigation()
	const transition = document.querySelector('.transition')

	const initComponents = (data) => {
		initAbout()
		initParallax(data.next.container)
		initLottieAnimations()
		initInviewAnimations()
		initAnimations()
		initCollections()
		initProduct()
		initSwiper()
		initBannerWordTicker()
		initLogos()
		initFragranceModel()
		initCursor(data.next.container.dataset.template)
	}

	barba.init({
		debug: false,
		timeout: 10000,
		schema: {
			prefix: 'data-load'
		},
		transitions: [
			{
				name: 'basic-transition',
				sync: true,
				once(data) {},
				leave(data) {
					const done = this.async()

					transition.style.pointerEvents = 'auto'

					gsap.to(transition, {
						opacity: 1,
						duration: 0.35,
						onComplete: done
					})
					
				},
				afterLeave() {
					scrollToStart()
					nav.closeNavigation()
					ScrollTrigger.getAll().forEach(t => t.kill())
				},
				after(data) {
					const done = this.async();
					const next = data.next.container
					const funcA = document.querySelector('#reveal-filter feFuncA')

					transition.style.pointerEvents = 'none'

					console.log(next)
    
					gsap.timeline({
						onComplete: done
					})
					.to(transition, {
						opacity: 0,
						duration: 0.6
					})
					// .set(next, {
					// 	filter: 'url(#reveal-filter)',
					// })
					// .set(funcA, {
					// 	attr: { intercept: -8 }
					// })
					// .to(funcA, {
					// 	attr: { intercept: 1.5 },
					// 	duration: 3,
					// 	ease: 'power4.inOut',
					// })
					// .set(next, {
					// 	filter: 'none'
					// })

					// gsap.from(data.next.container, {
					// 	opacity: 0,
					// 	duration: 0.5,
					// 	onComplete: done
					// })
				}
			}
		]
	})

	barba.hooks.once((data) => {
		setTemplateName(data.next.container)
		initLenis()
		initAlpine()
		initPreloader()
		initComponents(data)


		window.onload = function() {
			window.initialLoad = false
			document.documentElement.classList.add('is-ready')
		}
	})

	barba.hooks.beforeLeave((data) => {
		gsap.killTweensOf('*')
	})

	barba.hooks.enter((data) => {
		setTemplateName(data.next.container)
		lenis.start()
	})

	barba.hooks.after((data) => {
		initComponents(data)

		gtag('event', 'page_view', {
			'page_title': document.title,
			'page_location': location.href,
			'page_path': location.pathname,
		})
	})
}

export default initBarba